
import { Component, Vue } from "vue-property-decorator";
import { SessionManager } from "@/components/utils/utils";
import NavigationTips from "./NavigationTips.vue";
import LegalAssistanceFaq from "@/components/utils/LegalAssistanceFaq.vue";
import LanguageResources from '@/components/utils/LanguageResources.vue';

import moment from "moment-timezone";

import { namespace } from "vuex-class";   
import "@/store/modules/common";
const commonState = namespace("Common");

@Component({
    components: {
        NavigationTips,
        LegalAssistanceFaq,
        LanguageResources
    }
})
export default class NavigationTopbar extends Vue {

    @commonState.State
    public userHasStatisticsAccess!: boolean;

    error = "";
    getHelp = false;
    tips = false;
    showLegalAssistance = false;
    showFamilyLawIssueResolutionInfo = false;
    showHelpFillingForms = false;
    languageResource = false;

    mounted() {
        this.getHelp = false;
        this.tips = false;
        this.showLegalAssistance = false;
        this.showFamilyLawIssueResolutionInfo = false;
        this.showHelpFillingForms = false;
        this.languageResource = false;
    }

    public viewStats() {
        this.$router.push({name: "statistics" })
    }

    get userName() {

        return this.$store.state.Application.userName;
    }

    public logout(isQuickExit) {

        const emptyApplicationRoutes = ["/", "/status", "/serviceLocator"];

        if (emptyApplicationRoutes.indexOf(this.$route.fullPath) == -1) {

            const lastUpdated = moment().format();
            this.$store.commit("Application/setLastUpdated", lastUpdated);
            const application = this.$store.state.Application;
            application.type = Vue.filter("translateTypes")(
                this.$store.state.Application.types
            );

            const applicationId = application.id;
            const header = {
                responseType: "json",
                headers: {
                    "Content-Type": "application/json"
                }
            };

            this.$http.put("/app/" + applicationId + "/", application, header).then(
                res => {
                    this.error = "";
                },
                err => {
                    console.error(err);
                    this.error = err;
                }
            );
        }
        Vue.nextTick().then(() => {

            if (isQuickExit) {
                window.open("http://www.google.ca");
                SessionManager.logoutAndRedirect(this.$store);
            } else SessionManager.logout(this.$store);
        });

    }

    public viewStatus() {
        if(this.$route.name != "applicant-status")
            this.$router.push({ name: "applicant-status" });
    }
}
